import React, { Component } from 'react';
import { icons } from 'assets';
import styles from './LabeledDropdown.module.scss';
import { Button, IconButton, Icon } from 'components';
// import { IconButton } from '..';

// interface Color {
//   n: string;
//   v: string;
// }

interface Props {
  maxSelections?: number;
  placeholder?: string;
  options: string[] | any[];
  label?: string;
  className?: string;
  onSelect?: (selectedArr: string[] | any[]) => void;
  selectedOptions?: string[] | any[];
  error?: boolean;
  size?: 'mini' | 'small' | 'big';
  optionClassName?: string;
}

interface State {
  inputWidth: number;
  showDropdown: boolean;
  selectedOptions: string[] | any[];
}

class LabeledDropdown extends Component<Props, State> {
  inputContainer: any;
  inputRef: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      inputWidth: 100,
      showDropdown: false,
      selectedOptions: []
    };

    this.inputContainer = React.createRef();
    this.inputRef = React.createRef();

    this.handleWidthChange = this.handleWidthChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    // if (this.props.value) {

    // }
    window.addEventListener('transitionend', this.handleWidthChange);
    window.addEventListener('resize', this.handleWidthChange);

    this.handleWidthChange();
  }

  componentWillUnmount() {
    window.removeEventListener('transitionend', this.handleWidthChange);
    window.removeEventListener('resize', this.handleWidthChange);
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  handleWidthChange() {
    this.setState({ inputWidth: this.inputRef.current.offsetWidth });
  }

  handleSelect(value: string | any) {
    // let value: string = '';

    // typeof incomingValue === 'string'
    //   ? value = incomingValue
    //   : value = incomingValue.name;

    const {
      maxSelections = 1,
      onSelect,
      selectedOptions: propsSelectedOptions
    } = this.props;
    let selectedOptions = propsSelectedOptions
      ? [...propsSelectedOptions]
      : [...this.state.selectedOptions];
    let showDropdown = true;
    const excludeOption = selectedOptions.includes(value);

    if (maxSelections !== 1
      && selectedOptions.length >= maxSelections
      && !excludeOption
    ) return;

    switch (true) {
      case (maxSelections === 1):
        selectedOptions = [value];
        showDropdown = false;
        break;

      case (excludeOption):
        selectedOptions = selectedOptions.filter(option => option !== value);
        break;

      default:
        selectedOptions.push(value);
        if (maxSelections && selectedOptions.length === maxSelections) {
          showDropdown = false;
        }
        break;
    }

    this.setState({ selectedOptions, showDropdown }, () => {
      onSelect && onSelect(selectedOptions);
    });
  }

  handleInputFocus() {
    const { showDropdown } = this.state;

    if (!showDropdown) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState({ showDropdown: !showDropdown });
  }

  handleOutsideClick(e: any) {
    const clickedInside = this.inputContainer.current.contains(e.target);

    if (clickedInside) return;

    document.removeEventListener('click', this.handleOutsideClick, false);
    this.setState({ showDropdown: false });
  }

  render() {
    const {
      placeholder,
      options,
      label,
      className,
      error,
      selectedOptions: propsSelectedOptions,
      size = 'normal',
      optionClassName = ''
    } = this.props;

    const {
      inputWidth,
      showDropdown,
      selectedOptions: stateSelectedOptions
    } = this.state;

    const selectedOptions = propsSelectedOptions || stateSelectedOptions;
    const areOptionsStrings = options.length && typeof options[0] === 'string';
    const containerStyles = [styles.container];
    size !== 'normal' && containerStyles.push(styles[size]);
    className && containerStyles.push(className);
    const inputStyles = [styles.input];
    error && inputStyles.push(styles.error);
    showDropdown && inputStyles.push(styles.focused);

    return (
      <div className={containerStyles.join(' ')}>
        {label && <label htmlFor=''>{label}</label>}
        <div
          className={styles.inputContainer}
          ref={this.inputContainer}
        >
          <input
            ref={this.inputRef}
            className={inputStyles.join(' ')}
            value={areOptionsStrings
              ? selectedOptions.join(', ')
              : selectedOptions.map(o => o.name).join(', ')
            }
            contentEditable={false}
            onChange={() => null}
            type='text'
            placeholder={placeholder}
            onFocus={this.handleInputFocus}
          />

          <IconButton
            className={styles.dropdownIcon}
            style={{ marginLeft: inputWidth - 20 }}
            icon={showDropdown ? icons.arrowUp : icons.arrowDown}
            onClick={this.handleInputFocus}
          />

          {showDropdown &&
            <div className={`${styles.dropdown} dropdown-container`} style={{ width: inputWidth }}>
              {(options as any[]).map((option, index) => {
                // const isColor = typeof option !== 'string' &&
                //   option.hasOwnProperty('n') &&
                //   option.hasOwnProperty('v');
                const checked = areOptionsStrings
                  ? selectedOptions.includes(option)
                  : selectedOptions.findIndex(selectedOption => {
                    return selectedOption.id
                      ? selectedOption.id === option.id
                      : selectedOption.value
                        ? selectedOption.value === option.value
                        : false;
                  }) > -1;

                return (
                  <Button
                    key={index}
                    className={`${styles.option} ${optionClassName}`}
                    onClick={() => this.handleSelect(option)}
                  >
                    {areOptionsStrings
                      ? option
                      : option.value && option.value.startsWith('#')
                        ? <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{
                            width: 15, height: 15,
                            borderRadius: 15,
                            boxShadow: '#00000030 0 1px 3px 0',
                            background: option.value,
                            // display: 'inline-block',
                            marginRight: 5
                          }} />
                          {option.name}
                        </div>
                        : option.name
                    }

                    {checked && <Icon icon={icons.checked} className={styles.checkedIcon} />}
                  </Button>
                );
              })}
            </div>
          }
        </div>
      </div>
    );
  }
}

export default LabeledDropdown;
